var _defs, _rect, _path, _path2, _path3, _path4, _rect2;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgOutagesicon(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Capa_1",
    "data-name": "Capa 1",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    viewBox: "0 0 20 20",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("style", null, "\n      .cls-1 {\n        fill: #bcbec0;\n      }\n\n      .cls-1, .cls-2 {\n        stroke-width: 0px;\n      }\n\n      .cls-2 {\n        fill: url(#Degradado_sin_nombre_2);\n      }\n    "), /*#__PURE__*/React.createElement("linearGradient", {
    id: "Degradado_sin_nombre_2",
    "data-name": "Degradado sin nombre 2",
    x1: 4.62,
    y1: -114.15,
    x2: 15.38,
    y2: -114.15,
    gradientTransform: "translate(0 -106.74) scale(1 -1)",
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    stopColor: "#3250fc"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.33,
    stopColor: "#9e70ff"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.67,
    stopColor: "#2aceeb"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#2cbf38"
  })))), _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    className: "cls-1",
    x: 9.32,
    y: 4.28,
    width: 1.36,
    height: 11.45
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "m5.93,7.34h-.67v-.95h0c.09-.19.32-.26.5-.17.07.04.13.1.17.17h0v.95Z"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "m7.47,7.34h-.67v-.95h0c.09-.19.32-.26.5-.17.07.04.13.1.17.17h0v.95Z"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "m13.2,7.34h-.67v-.95h0c.09-.19.32-.26.5-.17.07.04.13.1.17.17h0v.95Z"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "m14.74,7.34h-.67v-.95h0c.09-.19.32-.26.5-.17.07.04.13.1.17.17h0v.95Z"
  })), _rect2 || (_rect2 = /*#__PURE__*/React.createElement("rect", {
    className: "cls-2",
    x: 4.62,
    y: 7.08,
    width: 10.77,
    height: 0.67
  })));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgOutagesicon);
export default __webpack_public_path__ + "static/media/outagesicon.b3a1eca33af56b2db6618b283bb426a1.svg";
export { ForwardRef as ReactComponent };